export default __webpack_public_path__ + "static/media/discovery-placeholder.8f863116.png";